import useLegendStore from '../../../../store/legendStore';
import { useCallback, useState } from 'react';
import { useMarkerStore } from '../../../../store/markerStore';
import { IMarker } from '../../../../types/marker';
import { useOverlayGeojsonMutation } from '../../../../queries/useOverlayGeojsonMutation';
import { IPolygonLayer } from '../../Map/Layer/DatasetZoneLayer';

export const useLayerControls = (
  onMeshControl: (value: string) => any,
  point: IMarker | null,
  isHavePoint: boolean,
  isHave2DSpectra: boolean
) => {
  const [showLayerSection, setShowLayerSection] = useState(true);

  const updateMarker = useMarkerStore((state) => state.updateMarker);
  const showDatasetZones = useLegendStore((state) => state.showDatasetZones);
  const setShowDatasetZones = useLegendStore(
    (state) => state.setShowDatasetZones
  );
  const showGlobalShapeFile = useLegendStore(
    (state) => state.showGlobalShapeFile
  );
  const setShowGlobalShapeFile = useLegendStore(
    (state) => state.setShowGlobalShapeFile
  );
  const showMesh = useLegendStore((state) => state.showMesh);
  const setShowMesh = useLegendStore((state) => state.setShowMesh);
  const getOverlayGeojson = useOverlayGeojsonMutation();

  const updateMeshSwitch = (state: boolean) => {
    if (point) {
      setShowMesh(state);
      if (state) onMeshControl(point.dataset);
      else onMeshControl('');
    }
  };

  const updateShowShape = useCallback(
    async (
      state: boolean,
      id: string,
      level1: string,
      level2: string,
      color: string
    ) => {
      if (!point || !point.id) return;

      const shape = point.shapeFiles.find(
        (x) => x.Level1 === level1 && x.Level2 === level2
      );

      if (!shape) return;

      shape.IsDisplay = state;

      const updatedShapeFiles = [...point.shapeFiles].map((file) => {
        if (file.Level1 === level1 && file.Level2 === level2) {
          return shape;
        }
        return file;
      });

      updateMarker(point.id, { shapeFiles: updatedShapeFiles });

      if (state && shape?.data === undefined) {
        getOverlayGeojson.mutate(
          { id, level1, level2, color },
          {
            onSuccess: (result: IPolygonLayer[]) => {
              if (!point || !point.id) return;

              const currentShape = point.shapeFiles.find(
                (x) => x.Level1 === level1 && x.Level2 === level2
              );

              if (!currentShape) return;

              const updatedShape = {
                ...currentShape,
                data: result,
              };

              const updatedShapeFilesWithData = [...point.shapeFiles].map(
                (file) => {
                  if (file.Level1 === level1 && file.Level2 === level2) {
                    return updatedShape;
                  }
                  return file;
                }
              );

              updateMarker(point.id, { shapeFiles: updatedShapeFilesWithData });
            },
          }
        );
      }
    },
    [point, updateMarker, getOverlayGeojson]
  );

  return {
    showLayerSection,
    showDatasetZones,
    setShowDatasetZones,
    showGlobalShapeFile,
    setShowGlobalShapeFile,
    showMesh,
    isHavePoint,
    isHave2DSpectra,
    point,
    setShowLayerSection,
    updateMeshSwitch,
    updateShowShape,
  };
};
